module.exports = __webpack_public_path__ + "img/x13.83262e33.jpg";